import qs from 'qs'
import { create, ApiResponse } from 'apisauce'
import config from 'config'

/**
 * Will throw an exception if server returned an error
 * @param res
 */
export const responseErrorCheck = <T = any>(res: ApiResponse<T, any>) => {
  if (res?.status === 0 || res?.problem === 'UNKNOWN_ERROR') {
    throw new Error('Server error')
  }

  if (res && (res.status === 200 || res.status === 204)) {
    return res.data as T
  }

  if (res.status === 401 && res.config?.url === '/login') {
    // showNotification('Errore', 'Credenziali errate', 'error')
    throw new Error('Credential error')
  }

  if ((res.status === 401 || res.status === 404 || res.status === 400) && res.data) {
    throw res.data;
  }

  if (res.status === 401) {
    // showNotification('Errore', 'Non autorizzato', 'error')
    // TODO RIMUOVI TOKEN E REFRESHA PAGINA PER ANDARE IN LOGIN
    throw new Error('Not authorized')
  }

  if (res.status === 403) {
    throw new Error("You don't have permission to access this resource")
  }

  if (res.status === 404) {
    throw new Error(res?.data?.message ?? '404 Error')
  }

  if (res?.status && res?.status >= 400) {
    const errorHasCode = res.data?.errorCode !== undefined || res.data?.messageCode !== undefined
    throw new Error(
      `${res.data?.errorCode ?? res.data?.messageCode ?? ''}${errorHasCode ? ': ' : ''}${res.data?.message}` ??
      'Generic Error'
    )
  }

  if (res.data && res.data.error?.message) {
    // showNotification(res.data.error.message, 'danger')
    throw new Error('Error')
  }

  if (!res || !res.data) {
    // showNotification('Malformed Response from server', 'danger')
    throw new Error('Malformed Response from server')
  }

  if (res.problem) {
    // showNotification(res.data?.message || res.problem, 'danger')
    throw new Error('Error')
  }

  return res.data
}

/**
 * Apisauce params serializer adapted to TMR API
 */
const paramsSerializer = (params: any) =>
  qs.stringify(params, {
    // TMR API handles multiple values with format ?code=A&code=B, but default serializer
    // uses format ?code[]=A&code[]=B so override with option arrayFormat: repeat
    arrayFormat: 'repeat',
    // TMR API date format is unix timestamp in milliseconds
    // Note: this will not usually be used as date params are converted to timestamp
    // as soon as they're parsed from user input
    serializeDate: (Date) => Date.getTime().toString(),
  })

const api = create({
  baseURL: config.endpoint,
  // timeout: 40000,
  headers: {
    accept: '*/*',
    'Content-Type': 'application/json',
  },
  paramsSerializer,
})

api.axiosInstance.interceptors.response.use(
  (response) => response,
  // eslint-disable-next-line consistent-return
  (error) => {
    // if on login page respond with 401
    if (error.request.responseURL.includes('/login')) {
      return Promise.reject(error)
    }
    if (error.response.status === 401) {
      // alert('session expired')
      // DeviceEventEmitter.emit('AccessTokenExpired')
      return Promise.reject(error)

    } else {
      return Promise.reject(error)
    }
  }
)

// export const translateErrorMessage = (message: string) => {
//   return message
// }

// export default create({
//   baseURL: 'https://localhost', // this is useless, each resource will define the baseUrl
//   timeout: 30000,
// })

export { api }
